export const getPXLWorkGroupRoute = () => '/work-group';